import SaudiGreenBg from '../../../assets/images/wallpaper/saudi-green.jpg';
import MainHeader from "../../../layouts/MainHeader";
import saudiGreenPageData from "../../../data/arabic/saudi-green-page-data-ar";
import BorderCenterCard from "../../../components/cards/BorderCenterCard";
import Separator from "../../../components/Separator";
import BorderLeftBox from "../../../components/boxes/BorderLeftBox";
import VerticalTabs from "../../../components/tabs/VerticalTabs";
import TextAndImageSection from "../../../components/sections/TextAndImageSection";
import Footer from "../../../layouts/Footer";
import ReactVisibilitySensor from "react-visibility-sensor";
import TitleBorderLeft from '../../../components/Text/TitleBorderLeft';

const SaudiGreenPageAr = () => {
    return (
        <main id="main" className="page">
            <div className="sticky-view-two">
                <div className="sticky-container">
                    <MainHeader title="" image={{
                        alt : "Saudi green initiative background",
                        src : SaudiGreenBg,
                    }} />
                </div>
                <div className="sticky-container-two" id="mainContent">
                    <div className="wrapper-small">
                        <h1 className="title-center">{saudiGreenPageData.title}</h1>
                        <article className="text-paragraph">{saudiGreenPageData.paraghraph}</article>
                    </div>
                    <div className="margin-box"></div>
                    <BorderCenterCard 
                        cards={[{
                            icon : {
                                src : require(`../../../assets/icons/initiative/${saudiGreenPageData.cardOne.icon.name}`),
                                alt : saudiGreenPageData.cardOne.icon.alt,
                            },
                            title : saudiGreenPageData.cardOne.title,
                            subtitle : saudiGreenPageData.cardOne.subtitle,
                            subtitleTwo : saudiGreenPageData.cardOne.subtitleTwo
                        }]}
                    />
                    <div className="space-50"></div>
                    <Separator />
                    <div className="space-50"></div>
                    <div className='wrapper-small'>
                        <VerticalTabs 
                            tablist={[
                                " تحسين الأصول الطبيعية للمملكة",
                                "مركز حفظ النباتات المحلية وإكثارها",
                            ]} 
                            title="دراسة حالة"
                            
                        />
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <Separator />
                        <div className="space-50"></div>
                        <BorderLeftBox 
                            title={saudiGreenPageData.sectionOne.title}
                            subtitle={saudiGreenPageData.sectionOne.subtitle}
                        />
                        <BorderLeftBox 
                            title={saudiGreenPageData.sectionTwo.title}
                            subtitle={saudiGreenPageData.sectionTwo.subtitle}
                            
                        />
                        <p className="text-paragraph">{saudiGreenPageData.sectionTwo.subtitleTwo}</p>
                    </div>
                    <div className="wrapper-larg">
                        <TextAndImageSection 
                            title=""
                            image={{
                                src : require('../../../assets/images/sections/water-in-desert.jpg'),
                                alt : "Boat in rever"
                            }}
                        />
                    </div>
                    <div className="wrapper-small">
                        
                        <TitleBorderLeft>{saudiGreenPageData.sectionFour.title}</TitleBorderLeft>
                        <p className={`text-paragraph`}>{saudiGreenPageData.sectionFour.paraghraphOne}</p>
                        <p className={`text-paragraph`}>{saudiGreenPageData.sectionFour.paraghraphTwo}</p>
                    </div>
                    <div className="margin-box"></div>
                    <Footer withBlogs={false} />
                </div>
            </div>
        </main>
  )
}

export default SaudiGreenPageAr